import * as React from 'react';

function SvgPlayButton(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <circle cx={50} cy={50} r={50} fill="#DF4046" />
    <path
      fill="#fff"
      d="M70.449 47.38a2 2 0 0 1 0 3.388L41.712 68.802c-1.332.836-3.064-.121-3.064-1.694V31.04c0-1.573 1.732-2.53 3.063-1.694z"
    />
  </svg>)
}
export default SvgPlayButton;
